import React from 'react';
import Splash_Signin from '../commons/splash_signin';
import {IndexLink, Link} from 'react-router';
var querystring = require('querystring');
import axios from 'axios';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Footer2Component from "../commons/footer2";

export default class ServicesBrowsePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            first_name_lead: '',
            last_name_lead: '',
            email_name_lead: '',
            title_name_lead: '',
            part_name_lead: '',
            subscrible_name_lead: 0,
            errors: {},
            menuShow: false,
        }
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        window.location = link;
    }

    render() {

		if (isMobile) {
            return (
                <div className="companies_boxx" id="v-enterprise-browse_mobile">
                    <div className={"block-001 row mr0"}>
                        <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/home2/m-logo.png"/></Link>
                        <div className={"mobile-dropdown"}>
                            <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                <title>Menu</title>
                                <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                            <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                <li onClick={() => this.mouseLinkClick("/signup")}><span>Join</span></li>
                                <li onClick={() => this.mouseLinkClick("/signin")}><span>Sign in</span></li>
                            </ul>
                        </div>
                        <div className="col-xs-12 text-center t-content">
                            <h2>Browse all Versity services</h2>
                            <p>Find the right students and recent grads for your business</p>
                            <a className="btn" href="/signup">Get Started</a>
                        </div>
                        <img className="img_logo_bg cls-image-line" src={"/static/img/homeimg/home2/img-01-line.png"}/>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content popular-services">
                        <div className="div-block-10">
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
                                        Accounting
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Accounting
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Bookkeeping
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Financial Accounting
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Financial Advisory
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Mortgage Lending
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Personal Tax Planning
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Small Business Tax
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Tax Preparation
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="3387"
                                        tabIndex="-1">
                                        Design
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        3D Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Ad Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Animation
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Brand Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Engineering Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Graphic Design
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Illustration
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Industrial Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Interaction Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Interior Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Logo Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Packaging Design
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Presentation Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Print Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        UX Research
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        User Experience Design (UED)
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Video Editing
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Video Production
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Videography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Visual Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Web Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        WordPress Design
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="58" tabIndex="-1">
                                        Finance
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Budgeting
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Financial Accounting
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Financial Advisory
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Financial Analysis
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Financial Planning
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Financial Reporting
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Insurance
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Loans
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Retirement Planning
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Wealth Management
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="3420"
                                        tabIndex="-1">
                                        Home Improvement
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Architecture
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Interior Design
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Landscape Design
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="4725"
                                        tabIndex="-1">
                                        Information Technology
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Backup &amp; Recovery Systems
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Computer Networking
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Computer Repair
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Cybersecurity
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Data Recovery
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Home Networking
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        IT Consulting
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Network Support
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Telecommunications
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="340" tabIndex="-1">
                                        Insurance
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Auto Insurance
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Commercial Insurance
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Health Insurance
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Homeowners Insurance
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Insurance
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Life Insurance
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Small Business Insurance
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Title Insurance
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="172" tabIndex="-1">
                                        Law
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Bankruptcy Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Business Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Consumer Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Copyright Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Corporate Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Criminal Defense Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        DUI Law
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Divorce Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Entertainment Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Estate Planning Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Family Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        IT Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Immigration Law
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Intellectual Property Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Labor and Employment Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Legal Consulting
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Notary
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Patent Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Personal Injury Law
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Property Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Startup Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Tax Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Trademark Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Trust and Estate Litigation
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Wills Planning Law
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="2461"
                                        tabIndex="-1">
                                        Marketing
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Advertising
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Blogging
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Brand Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Content Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Content Strategy
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Demand Generation
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Digital Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Direct Mail Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Email Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Event Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Growth Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Lead Generation
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Market Research
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Marketing Consulting
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Marketing Strategy
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Mobile Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Performance Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Product Marketing
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Public Relations
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Real Estate Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Search Engine Marketing (SEM)
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Search Engine Optimization (SEO)
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Social Media Marketing
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="63" tabIndex="-1">
                                        Operations
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Administrative Assistance
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Appointment Scheduling
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Customer Service
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Customer Support
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Data Entry
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Data Reporting
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Executive Administrative Assistance
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        File Management
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Filing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Human Resources (HR)
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Invoice Processing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Online Research
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Outsourcing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Payroll Services
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Personal Assistance
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Program Management
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Project Management
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Research
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Strategic Planning
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Technical Support
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Transcription
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Typing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Virtual Assistance
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="193" tabIndex="-1">
                                        Photography
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Commercial Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Corporate Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Event Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Food Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Headshot Photography
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Nature Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Pet Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Photo Booths
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Portrait Photography
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Real Estate Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Restaurant Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Sports Photography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Stock Photography
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Video Animation
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Video Editing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Videography
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Wedding Photography
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="123" tabIndex="-1">
                                        Real Estate
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Commercial Lending
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Commercial Real Estate
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Mortgage Lending
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Property Law
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Property Management
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Real Estate
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Real Estate Appraisal
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Real Estate Marketing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Relocation
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="602" tabIndex="-1">
                                        Software Development
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Android Development
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Application Development
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Business Analytics
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Cloud Application Development
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Cloud Management
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Custom Software Development
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Database Development
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Enterprise Content Management
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Information Management
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Information Security
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Mobile Application Development
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        SaaS Development
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Software Testing
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        User Experience Design (UED)
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Web Design
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Web Development
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        iOS Development
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="link-table">
                                <div className="link-table__header-section">
                                    <h2 className="link-table__top-section-header scroll-anchor" id="86" tabIndex="-1">
                                        Writing
                                    </h2>
                                </div>
                                <section className="linkster link-table__linkster">
                                    <div className="linkster__container">
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Blogging
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Content Strategy
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Copywriting
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Editing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Ghostwriting
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Grant Writing
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Technical Writing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Translation
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="link-column">

                                            <ul className="link-column__list">
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        User Experience Writing
                                                    </a>
                                                </li>
                                                <li className="link-column__item">
                                                    <a className="link-column__link"
                                                       data-tracking-will-navigate="">
                                                        Writing
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <Footer2Component isSlash={true}/>
                </div>
            )
        }

        return (
            <div id="splash" className="v-home">
                <header>
                    <div className="header">
                        <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                        <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                    </div>
                </header>
                <div id="v-enterprise-browse" className="splash_wrapper companies_boxx">
                    <div className="splash-block row pd0">
                        <div className="row tops">
                            <div className="t-header">
                                <div className="content">
                                    <h1 className="title">Browse all Versity services</h1>
                                    <span className="sub-title">Find the right students and recent grads for your business</span>
                                </div>
                            </div>
                            <div className="t-footer">
                                <div className="content">
                                    <a className="btn" href="/signup">Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row main-content popular-services">
                        <div className="learning-center-section">
                            <div className="page-center">
                                <div className="learning-center-inner">
                                    <div className="learning-center-heading">
                                        <h2>Browse Micro-Internship Templates</h2>
                                    </div>

                                    <div className="learning-center-box-wrapp">
                                        <div className="learning-center-row">
                                            <div className="learning-center-box">
                                                <a href="/services/tag/most-popular">
                                                    <div
                                                        className="learning-center-box-inner"
                                                        style={{backgroundColor: 'rgb(240, 240, 240)', height: '304px'}}>
                                                        <div
                                                            className="learning-center-image-block">
                                                            <img
                                                                src="/static/img/appimg/services/Studentdoeswork-200.png"
                                                                alt="Studentdoeswork-200"/>
                                                        </div>
                                                        <div
                                                            className="learning-center-text-block">
                                                            <h6>Most Popular</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>

                                            <div className="learning-center-box">
                                                <a href="/services/tag/finance-accounting">
                                                    <div
                                                        className="learning-center-box-inner"
                                                        style={{backgroundColor: 'rgb(240, 240, 240)', height: '304px'}}>
                                                        <div
                                                            className="learning-center-image-block">
                                                            <img
                                                                src="/static/img/appimg/services/class-200.png"
                                                                alt="class-200"/>
                                                        </div>
                                                        <div
                                                            className="learning-center-text-block">
                                                            <h6>Finance &amp; Accounting</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>

                                            <div className="learning-center-box">
                                                <a href="/services/tag/sales-business-development">
                                                    <div
                                                        className="learning-center-box-inner"
                                                        style={{backgroundColor: 'rgb(240, 240, 240)', height: '304px'}}>
                                                        <div
                                                            className="learning-center-image-block">
                                                            <img
                                                                src="https://www.parkerdewey.com/hubfs/Getexperience-200.png"
                                                                alt="Getexperience-200"/>
                                                        </div>
                                                        <div
                                                            className="learning-center-text-block">
                                                            <h6>Sales &amp; Business
                                                                Development</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>

                                            <div className="learning-center-box">
                                                <a href="/services/tag/human-resources">
                                                    <div
                                                        className="learning-center-box-inner"
                                                        style={{backgroundColor: 'rgb(240, 240, 240)', height: '304px'}}>
                                                        <div
                                                            className="learning-center-image-block">
                                                            <img
                                                                src="/static/img/appimg/services/Preparestudents-200.png"
                                                                alt="Preparestudents-200"/>
                                                        </div>
                                                        <div
                                                            className="learning-center-text-block">
                                                            <h6>Human Resources</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>

                                            <div className="learning-center-box">
                                                <a href="/services/tag/research-strategy">
                                                    <div
                                                        className="learning-center-box-inner"
                                                        style={{backgroundColor: 'rgb(240, 240, 240)', height: '283px'}}>
                                                        <div
                                                            className="learning-center-image-block">
                                                            <img
                                                                src="/static/img/appimg/services/Collegesgetinsights-200.png"
                                                                alt="Collegesgetinsights-200"/>
                                                        </div>
                                                        <div
                                                            className="learning-center-text-block">
                                                            <h6>Research &amp; Strategy</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>

                                            <div className="learning-center-box">
                                                <a href="/services/tag/marketing">
                                                    <div
                                                        className="learning-center-box-inner"
                                                        style={{backgroundColor: 'rgb(240, 240, 240)', height: '283px'}}>
                                                        <div
                                                            className="learning-center-image-block">
                                                            <img
                                                                src="/static/img/appimg/services/collaboration-200.png"
                                                                alt="collaboration-200"/>
                                                        </div>
                                                        <div
                                                            className="learning-center-text-block">
                                                            <h6>Marketing</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>

                                            <div className="learning-center-box">
                                                <a href="/services/tag/operations-support">
                                                    <div
                                                        className="learning-center-box-inner"
                                                        style={{backgroundColor: 'rgb(240, 240, 240)', height: '283px'}}>
                                                        <div
                                                            className="learning-center-image-block">
                                                            <img
                                                                src="/static/img/appimg/services/GetPaid-200.png"
                                                                alt="GetPaid-200"/>
                                                        </div>
                                                        <div
                                                            className="learning-center-text-block">
                                                            <h6>Operations &amp; Support</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>

                                            <div className="learning-center-box">
                                                <a href="https://www.parkerdewey.com/projects/tag/it-cyber">
                                                    <div
                                                        className="learning-center-box-inner"
                                                        style={{backgroundColor: 'rgb(240, 240, 240)', height: '283px'}}>
                                                        <div
                                                            className="learning-center-image-block">
                                                            <img
                                                                src="/static/img/appimg/services/Postproject.png"
                                                                alt="Postproject"/>
                                                        </div>
                                                        <div
                                                            className="learning-center-text-block">
                                                            <h6>IT &amp; Cyber</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer2Component isSlash={true}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/services-browse.js
 **/